import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { DataTableFilterMessageService } from '../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { GuestFilterStateService } from '../../services/guest-filter-state.service';
import { GuestMessageService } from '../../services/guest-message.service';
import { BaseDataTableFilter } from '../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import { addFilterStatusToFilterStatusText } from '../../../../../utilities/TableFilterUtility';

@Component({
  selector: 'app-guest-filter-status',
  templateUrl: './guest-filter-status.component.html',
  styleUrls: ['./guest-filter-status.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatSlideToggle
  ]
})
export class GuestFilterStatusComponent extends BaseDataTableFilter implements OnInit {

  constructor(
    private filterStateService: GuestFilterStateService,
    private guestMessageService: GuestMessageService,
    private filterMessageService: DataTableFilterMessageService
  ) {
    super(filterMessageService);
  }

  ngOnInit(): void {
    if (this.filterStateService.isVerificationFilterActive()) {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  onPassedToggle(event: MatSlideToggleChange): void {
    this.filterStateService.passed = event.checked;
  }

  onConsiderToggle(event: MatSlideToggleChange): void {
    this.filterStateService.consider = event.checked;
  }

  onProcessingToggle(event: MatSlideToggleChange): void {
    this.filterStateService.processing = event.checked;
  }

  onNoVerificationToggle(event: MatSlideToggleChange): void {
    this.filterStateService.noVerification = event.checked;
  }

  onApplyClicked(): void {
    this.guestMessageService.applyFilter();

    if (this.filterStateService.allVerificationFiltersActive()) {
      this.filterMessageService.setActive({ filterId: this.id, active: false });
    } else {
      this.filterMessageService.setActive({ filterId: this.id, active: this.filterStateService.isVerificationFilterActive(), value: this.getFilterStatusText() });
    }
  }

  onClearClicked(): void {
    this.filterStateService.resetVerificationFilter();
    this.guestMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getStateService(): GuestFilterStateService {
    return this.filterStateService;
  }

  private getFilterStatusText(): any {
    const filterValue: string[] = [];
    addFilterStatusToFilterStatusText("PASSED", this.filterStateService.isPassedFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("CONSIDER", this.filterStateService.isConsiderFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("PROCESSING", this.filterStateService.isProcessingFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("NO VERIFICATION", this.filterStateService.isNoVerificationFilterActive(), filterValue);
    return filterValue;
  }
}